<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Administración de Equipos</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Administración de Equipos</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Principales Usos</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-building"></i>
                            <h3>Corporativos y oficinas</h3>
                            <p>Administración de estaciones de trabajo y redes empresariales.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-hospital"></i>
                             <h3>Hospitales y clínicas</h3>
                            <p>Gestión de hardware médico y almacenamiento de datos sensibles.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-school"></i>
                             <h3>Sector educativo</h3>
                            <p>Administración de laboratorios de cómputo y equipos de TI.
                            </p>
                        </div>
                    </div>
              
                  
                </div>
            </div>
        </div>
    </div>
</div>







<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">Administración de Equipos de Hardware</h2>
                    <p class="text-justify">
                        La infraestructura de TI es el núcleo operativo de cualquier empresa. En enCloud, ofrecemos administración remota y en sitio de hardware para garantizar alto rendimiento, mayor vida útil y continuidad operativa.
                        Nos encargamos de la gestión de servidores, estaciones de trabajo, redes, almacenamiento y dispositivos especializados, permitiendo que tu equipo se enfoque en su negocio sin preocuparse por el mantenimiento tecnológico.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>




<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Servicios de Administración de Hardware</h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-shield-heart"></i>
                            <h3>Monitoreo y Mantenimiento Preventivo</h3>
                            <div class="row">
                                <a>🔹 Supervisión en tiempo real de servidores, equipos de red y estaciones de
                                    trabajo.</a>
                                <a>🔹 Diagnóstico y mantenimiento preventivo y correctivo para evitar fallos.
                                </a>
                                <a>🔹 Optimización de rendimiento mediante actualizaciones y limpieza de hardware.
                                </a>
                                <a>🔹 Revisión periódica del estado de los discos, temperatura y consumo de recursos.
                                </a>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-server"></i>
                            <h3>Gestión de Servidores y Centros de Datos</h3>
                            <div class="row">
                                <a>🔹 Administración de servidores físicos y virtuales.</a>
                                <a>🔹 Instalación y configuración de hardware en centros de datos.
                                </a>
                                <a>🔹 Implementación de redundancia y alta disponibilidad.
                                </a>
                                <a>🔹 Administración de entornos Windows Server, Linux y VMware.
                                </a>

                              
                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-network-wired"></i>
                            <h3>Administración de Redes y Conectividad</h3>
                            <div class="row">
                                <a>🔹 Configuración y mantenimiento de routers, switches, firewalls y balanceadores de carga.</a>
                                <a>🔹 Segmentación de red para mayor seguridad.</a>
                                <a>🔹 Implementación de VPNs y redes privadas para teletrabajo.</a>
                                <a>🔹 Monitoreo de latencia, pérdida de paquetes y congestión de red.</a>

                              
                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-keyboard"></i>
                            <h3>Gestión de Estaciones de Trabajo y Periféricos</h3>
                            <div class="row">
                                <a>🔹 Instalación, configuración y mantenimiento de PCs, laptops e impresoras.</a>
                                <a>🔹 Diagnóstico y solución de problemas de hardware en tiempo real.</a>
                                <a>🔹 Configuración personalizada para cada departamento.</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>

<section class="domain-pricing-list-area pt-70">
    <div class="container">
        <div class="row">


            <div class="col-lg-12 col-md-12">
                <h2 class="custom-table-title">Resumen de Servicios</h2>
                <div class="custom-table">
                  
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Servicio</th>
                                <th scope="col">Descripción</th>
                                <th scope="col">Beneficios</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Monitoreo y mantenimiento preventivo
                                </td>

                                <td class="special">
                                    Supervisión continua y diagnóstico de servidores y equipos.
                                </td>
                                <td class="special">
                                    Reduce el tiempo de inactividad y mejora la vida útil del hardware.

                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Gestión de servidores y data centers
                                </td>

                                <td class="special">
                                    Administración de servidores físicos y virtuales en centros de datos propios o de
                                    terceros.
                                </td>
                                <td class="special">
                                    Asegura el rendimiento óptimo y la seguridad del sistema.
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Administración de redes y conectividad
                                </td>

                                <td class="special">
                                    Configuración y mantenimiento de routers, switches y firewalls. </td>
                                <td class="special">
                                    Optimiza la velocidad y estabilidad de la red.
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Gestión de estaciones de trabajo </td>

                                <td class="special">
                                    Instalación, configuración y mantenimiento de equipos de trabajo. </td>
                                <td class="special">
                                    Mantiene a los empleados productivos con hardware confiable.

                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Almacenamiento y seguridad de datos	 </td>

                                <td class="special">
                                    Implementación de soluciones NAS, SAN y copias de seguridad en la nube.</td>
                                <td class="special">
                                    Protege la información y permite la recuperación ante desastres.
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Soporte técnico y atención rápida</td>
                                <td class="special">
                                    Help Desk 24/7 para solución de incidencias.</td>
                                <td class="special">
                                    Respuesta rápida y eficiente para evitar interrupciones.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</section>



<section class="pricing-area pt-100">
    <div class="container">
        <div class="section-title">
            <h2>📦 Planes de Administración de Equipos</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete PYMEs</h3>
                        <p>Para pequeñas empresas y startups</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>Administración de Servidores (Hasta 2 servidores)</li>
                            <li><i class="flaticon-tick"></i> Monitoreo y Mantenimiento	(Cada 6 meses)</li>
                            <li><i class="flaticon-tick"></i> Gestión de Redes y Seguridad (Básico)</li>
                            <li><i class="flaticon-tick"></i> Soporte Técnico (24/7)</li>
                            <li><i class="flaticon-tick"></i> Consultoría IT y Optimización	(No incluido) </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete Empresa Mediana</h3>
                        <p>Para negocios en expansión</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>Administración de Servidores (Hasta 10 servidores)</li>
                            <li><i class="flaticon-tick"></i> Monitoreo y Mantenimiento	(Trimestral)</li>
                            <li><i class="flaticon-tick"></i> Gestión de Redes y Seguridad (Avanzado)</li>
                            <li><i class="flaticon-tick"></i> Soporte Técnico (24/7 con respuesta inmediata)</li>
                            <li><i class="flaticon-tick"></i> Consultoría IT y Optimización	(2 sesiones anuales de consultoría)</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete Empresa Mediana</h3>
                        <p>Para necesidades específicas</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>Administración de Servidores (Ilimitado)</li>
                            <li><i class="flaticon-tick"></i> Monitoreo y Mantenimiento	(Mensual)</li>
                            <li><i class="flaticon-tick"></i> Gestión de Redes y Seguridad (Personalizado)</li>
                            <li><i class="flaticon-tick"></i> Soporte Técnico (Contrato SLA con prioridad crítica)</li>
                            <li><i class="flaticon-tick"></i> Consultoría IT y Optimización	(4 sesiones anuales de consultoría)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>